import { render, staticRenderFns } from "./AdminOrderManagement.vue?vue&type=template&id=dcfc7964&scoped=true"
import script from "./AdminOrderManagement.vue?vue&type=script&lang=js"
export * from "./AdminOrderManagement.vue?vue&type=script&lang=js"
import style0 from "./AdminOrderManagement.vue?vue&type=style&index=0&id=dcfc7964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfc7964",
  null
  
)

export default component.exports